import "core-js/modules/es.array.push.js";
import { hasRole, isAdminNotConsultant, isHolding } from "@/js/http/auth.js";
export default {
  name: "AdminInventorySubMenusLinks",
  props: {
    loggedUserData: {
      type: Object,
      required: true
    },
    searchCriterias: {
      type: Object,
      required: false
    },
    isExternal: {
      type: Boolean,
      required: false,
      default: false
    },
    forceTab: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      canManage: false,
      canManagePos: false,
      canManageSupplierPrices: false,
      canManageWarehouses: false,
      selectedTab: null,
      tabs: {
        items: "items",
        purchaseOrder: "purchaseOrder",
        supplierPrices: "supplierPrices",
        movements: "movements",
        warehouses: "warehouses"
      }
    };
  },
  created: function created() {
    this.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK);
    this.canManagePos = hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
    this.canManageSupplierPrices = hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
    this.canManageWarehouses = hasRole(process.env.VUE_APP_ROLES_MANAGE_WAREHOUSES);
    this.selectedTab = this.$route.query.tab || this.tabs.items;
    if (this.forceTab) {
      this.selectedTab = this.forceTab;
    }
  },
  methods: {
    changeTab: function changeTab() {
      if (this.forceTab) {
        this.selectedTab = this.forceTab;
      }
      if (this.isExternal) {
        this.$router.push({
          name: "adminStockList",
          query: {
            tab: this.$route.query.tab
          },
          force: true
        }).catch(function () {});
      }
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
        this.$emit("tabChanged", this.$route.query.tab);
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
        this.$emit("tabChanged", this.selectedTab);
      }
      if (!this.selectedTab) {
        if (this.canManage) this.selectedTab = this.tabs.items;else if (this.$whitelabel.isAllowedToAccessPurchaseOrder) this.selectedTab = this.tabs.purchaseOrder;else this.selectedTab = this.tabs.movements;
      }
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isHolding: isHolding
  },
  watch: {
    $route: function $route(oldRoute, newRoute) {
      if (oldRoute.query.tab !== newRoute.query.tab) {
        this.changeTab();
      }
    }
  }
};